export const skipAbortEndpoints: string[] = [
  "/article_alert_subscribers",
  "/email_digest_recipients",
  "/email_digest_sections",
  "/profile_keywords",
  "/media_list_domains",
];
